<script>
    export let icon = '';
    export let color = '#474B50';
    export let size = 16;
    export let transform = '';
</script>

{#if icon == 'pause'}
    <svg
        on:click
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g {transform}>
            <path
                d="M10.3 4H6.7C6.58954 4 6.5 4.08954 6.5 4.2V19.8C6.5 19.9105 6.58954 20 6.7 20H10.3C10.4105 20 10.5 19.9105 10.5 19.8V4.2C10.5 4.08954 10.4105 4 10.3 4Z"
                fill={color}
            />
            <path
                d="M18.3 4H14.7C14.5895 4 14.5 4.08954 14.5 4.2V19.8C14.5 19.9105 14.5895 20 14.7 20H18.3C18.4105 20 18.5 19.9105 18.5 19.8V4.2C18.5 4.08954 18.4105 4 18.3 4Z"
                fill={color}
            />
        </g>
    </svg>
{/if}

{#if icon == 'logo'}
    <svg
        on:click
        width={size}
        height={size}
        viewBox="0 0 97 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="0.5" width="96" height="96" rx="40" fill="#FFFBF1" />
        <path
            d="M48.1767 78.5499C31.4974 78.5208 17.9813 65.0062 17.9501 48.3271C17.9509 48.3043 17.9513 48.2814 17.9511 48.2584C17.9504 48.1729 17.95 48.0872 17.95 48.0015C17.9492 31.1292 31.6262 17.4508 48.4985 17.4499C65.3708 17.4491 79.0492 31.1261 79.05 47.9984C79.0509 64.8707 65.3739 78.5491 48.5015 78.55C48.4158 78.55 48.3302 78.5496 48.2446 78.5489C48.2219 78.5487 48.1993 78.5491 48.1767 78.5499Z"
            fill="white"
            stroke="#87A7E6"
            stroke-width="3"
            stroke-linejoin="round"
        />
        <path
            d="M25.0484 53.2538C24.9686 52.3328 24.6895 49.8074 27.3677 49.134C28.8176 48.7695 30.6655 48.8603 31.6137 50.1521C32.5619 51.444 32.9822 52.7098 31.8745 53.7138C30.9245 54.5747 29.8075 55.231 27.8668 55.4469C26.3809 55.6122 25.1675 54.6294 25.0484 53.2538Z"
            fill="#1BDE6C"
        />
        <path
            d="M66.3174 49.3647C64.2799 49.0155 64.768 46.0492 66.6736 44.6504C67.7071 43.8918 68.1508 44.415 69.8189 43.9956C71.2688 43.631 72.0498 45.475 71.8268 46.2111C71.5238 47.2116 71.5949 48.5154 70.5185 48.7618C68.9447 49.1221 68.8642 49.8012 66.3174 49.3647Z"
            fill="#FF3E13"
        />
        <path
            d="M34.9804 61.7404L37.4414 59.8068C44.8467 54.8163 49.7365 51.5775 58.0741 49.178C63.0633 47.7422 61.63 53.4698 60.4915 54.4645C59.3531 55.4592 57.7565 56.3899 56.0379 57.67C50.1569 62.0505 46.3203 64.1033 39.5096 67.1307C37.0329 68.2316 35.5538 67.8079 34.1558 67.1166C32.2918 66.1949 32.7655 63.4807 34.9804 61.7404Z"
            fill="#FFC20D"
        />
        <path
            d="M36.9804 43.7404L39.4414 41.8068C46.8467 36.8163 51.7365 33.5775 60.0741 31.178C65.0633 29.7422 63.63 35.4698 62.4915 36.4645C61.3531 37.4592 59.7565 38.3899 58.0379 39.67C52.1569 44.0505 48.3203 46.1033 41.5096 49.1307C39.0329 50.2316 37.5538 49.8079 36.1558 49.1166C34.2918 48.1949 34.7655 45.4807 36.9804 43.7404Z"
            fill="#2D71F3"
        />
    </svg>
{/if}

{#if icon == 'flag'}
    <svg
        on:click
        width="17"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect y="0.788452" width="17" height="12.4231" rx="1.30769" fill="white" />
        <path
            d="M0 2.09615C0 1.37393 0.585474 0.788452 1.30769 0.788452H5.88462V13.2115H1.30769C0.585474 13.2115 0 12.6261 0 11.9038V2.09615Z"
            fill="#219653"
        />
        <path
            d="M17 11.9039C17 12.6261 16.4145 13.2115 15.6923 13.2115H11.1154V0.788471H15.6923C16.4145 0.788471 17 1.37395 17 2.09616V11.9039Z"
            fill="#219653"
        />
    </svg>
{/if}

{#if icon == 'dropdown'}
    <svg
        on:click
        width="10"
        height="6"
        viewBox="0 0 10 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.20711 0.5C0.761654 0.5 0.538571 1.03857 0.853553 1.35355L4.64645 5.14645C4.84171 5.34171 5.15829 5.34171 5.35355 5.14645L9.14645 1.35355C9.46143 1.03857 9.23835 0.5 8.79289 0.5H1.20711Z"
            fill="#616C74"
        />
    </svg>
{/if}

{#if icon == 'dialer'}
    <svg
        on:click
        width={size}
        height={size}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M27.3333 20.56V24.56C27.3349 24.9314 27.2588 25.2989 27.11 25.6392C26.9613 25.9794 26.7431 26.2848 26.4694 26.5358C26.1958 26.7869 25.8728 26.978 25.521 27.097C25.1692 27.2159 24.7965 27.2601 24.4267 27.2267C20.3238 26.7809 16.3827 25.3789 12.92 23.1334C9.69845 21.0862 6.96713 18.3549 4.92001 15.1334C2.66665 11.655 1.26434 7.69469 0.826679 3.57336C0.79336 3.20465 0.837179 2.83304 0.955346 2.48219C1.07351 2.13135 1.26344 1.80895 1.51303 1.53552C1.76263 1.2621 2.06642 1.04364 2.40507 0.894057C2.74372 0.744474 3.1098 0.667043 3.48001 0.666694H7.48001C8.12709 0.660326 8.7544 0.889466 9.24503 1.3114C9.73565 1.73334 10.0561 2.31929 10.1467 2.96003C10.3155 4.24012 10.6286 5.497 11.08 6.70669C11.2594 7.18393 11.2982 7.70258 11.1919 8.2012C11.0855 8.69982 10.8385 9.15751 10.48 9.52003L8.78668 11.2134C10.6848 14.5514 13.4486 17.3153 16.7867 19.2134L18.48 17.52C18.8425 17.1615 19.3002 16.9145 19.7988 16.8082C20.2975 16.7018 20.8161 16.7406 21.2933 16.92C22.503 17.3714 23.7599 17.6845 25.04 17.8534C25.6877 17.9447 26.2792 18.271 26.7021 18.77C27.1249 19.2691 27.3496 19.9061 27.3333 20.56Z"
            fill={color}
        />
    </svg>
{/if}

{#if icon == 'caller-avatar'}
    <svg
        on:click
        width={size}
        height={size}
        viewBox="0 0 61 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M30.5 5C23.95 5 18.625 10.325 18.625 16.875C18.625 23.3 23.65 28.5 30.2 28.725C30.4 28.7 30.6 28.7 30.75 28.725C30.8 28.725 30.825 28.725 30.875 28.725C30.9 28.725 30.9 28.725 30.925 28.725C37.325 28.5 42.35 23.3 42.375 16.875C42.375 10.325 37.05 5 30.5 5Z"
            fill="white"
        />
        <path
            d="M43.2 35.375C36.225 30.725 24.85 30.725 17.825 35.375C14.65 37.5 12.9 40.375 12.9 43.45C12.9 46.525 14.65 49.375 17.8 51.475C21.3 53.825 25.9 55 30.5 55C35.1 55 39.7 53.825 43.2 51.475C46.35 49.35 48.1 46.5 48.1 43.4C48.075 40.325 46.35 37.475 43.2 35.375Z"
            fill="white"
        />
    </svg>
{/if}

{#if icon == 'end-call'}
    <svg
        on:click
        width={size}
        height={size}
        viewBox="0 0 36 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32.0667 12.7895L34.8951 9.96106C35.1588 9.69955 35.3649 9.38586 35.5003 9.04009C35.6357 8.69431 35.6974 8.32407 35.6814 7.95307C35.6654 7.58208 35.5721 7.21851 35.4075 6.88565C35.2429 6.5528 35.0106 6.25799 34.7254 6.02011C31.509 3.43417 27.7309 1.63874 23.6946 0.778097C19.969 -0.0523638 16.1064 -0.0523632 12.3809 0.778097C8.32789 1.64433 4.53596 3.45308 1.31227 6.05783C1.028 6.29499 0.796214 6.58874 0.631684 6.92038C0.467154 7.25203 0.373482 7.61429 0.356631 7.98412C0.33978 8.35395 0.40012 8.72324 0.533809 9.06847C0.667498 9.4137 0.871607 9.72732 1.13314 9.98934L3.96157 12.8178C4.41462 13.2798 5.02022 13.5614 5.6655 13.6099C6.31078 13.6585 6.95171 13.4708 7.46882 13.0818C8.49336 12.296 9.6035 11.6286 10.7781 11.0924C11.2424 10.8818 11.6366 10.5425 11.914 10.1148C12.1913 9.68699 12.3403 9.18866 12.3431 8.67884L12.3431 6.2841C16.0456 5.26588 19.9543 5.26588 23.6568 6.2841V8.67884C23.6597 9.18866 23.8086 9.68699 24.086 10.1148C24.3634 10.5425 24.7576 10.8818 25.2219 11.0924C26.3965 11.6286 27.5066 12.296 28.5312 13.0818C29.0538 13.4751 29.7027 13.6627 30.3546 13.6088C31.0065 13.5549 31.6158 13.2633 32.0667 12.7895Z"
            fill={color}
        />
    </svg>
{/if}

{#if icon == 'add-note'}
    <svg
        on:click
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.5 20H21.5"
            stroke={color}
            fill={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M17 3.49998C17.3978 3.10216 17.9374 2.87866 18.5 2.87866C18.7786 2.87866 19.0544 2.93353 19.3118 3.04014C19.5692 3.14674 19.803 3.303 20 3.49998C20.197 3.69697 20.3532 3.93082 20.4598 4.18819C20.5665 4.44556 20.6213 4.72141 20.6213 4.99998C20.6213 5.27856 20.5665 5.55441 20.4598 5.81178C20.3532 6.06915 20.197 6.303 20 6.49998L7.53917 18.9608C7.51354 18.9864 7.48142 19.0046 7.44626 19.0134L3.82338 19.9191C3.6769 19.9558 3.54423 19.8231 3.58085 19.6766L4.48656 16.0537C4.49536 16.0186 4.51354 15.9864 4.53917 15.9608L17 3.49998Z"
            fill={color}
        />
    </svg>
{/if}

{#if icon == 'microphone'}
    <svg
        on:click
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M19.62 9.11999C19.23 9.11999 18.92 9.42999 18.92 9.81999V11.4C18.92 14.94 16.04 17.82 12.5 17.82C8.95999 17.82 6.07999 14.94 6.07999 11.4V9.80999C6.07999 9.41999 5.76999 9.10999 5.37999 9.10999C4.98999 9.10999 4.67999 9.41999 4.67999 9.80999V11.39C4.67999 15.46 7.80999 18.81 11.8 19.17V21.3C11.8 21.69 12.11 22 12.5 22C12.89 22 13.2 21.69 13.2 21.3V19.17C17.18 18.82 20.32 15.46 20.32 11.39V9.80999C20.31 9.42999 20 9.11999 19.62 9.11999Z"
            fill={color}
        />
        <path
            d="M12.5 2C10.06 2 8.08002 3.98 8.08002 6.42V11.54C8.08002 13.98 10.06 15.96 12.5 15.96C14.94 15.96 16.92 13.98 16.92 11.54V6.42C16.92 3.98 14.94 2 12.5 2ZM13.81 8.95C13.74 9.21 13.51 9.38 13.25 9.38C13.2 9.38 13.15 9.37 13.1 9.36C12.71 9.25 12.3 9.25 11.91 9.36C11.59 9.45 11.28 9.26 11.2 8.95C11.11 8.64 11.3 8.32 11.61 8.24C12.2 8.08 12.82 8.08 13.41 8.24C13.71 8.32 13.89 8.64 13.81 8.95ZM14.34 7.01C14.25 7.25 14.03 7.39 13.79 7.39C13.72 7.39 13.66 7.38 13.59 7.36C12.89 7.1 12.11 7.1 11.41 7.36C11.11 7.47 10.77 7.31 10.66 7.01C10.55 6.71 10.71 6.37 11.01 6.27C11.97 5.92 13.03 5.92 13.99 6.27C14.29 6.38 14.45 6.71 14.34 7.01Z"
            fill={color}
        />
    </svg>
{/if}

{#if icon == 'microphone-mute'}
    <svg
        on:click
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.92 6.42001V7.58001L9.63996 14.86C8.67996 13.99 8.07996 12.71 8.07996 11.34V6.42001C8.07996 4.36001 9.47996 2.65002 11.38 2.16002C11.57 2.11002 11.75 2.27002 11.75 2.46001V4.00001C11.75 4.41001 12.09 4.75002 12.5 4.75002C12.91 4.75002 13.25 4.41001 13.25 4.00001V2.46001C13.25 2.27002 13.43 2.11002 13.62 2.16002C15.52 2.65002 16.92 4.36001 16.92 6.42001Z"
            fill={color}
        />
        <path
            d="M20.31 9.81V11.4C20.31 15.47 17.18 18.82 13.2 19.17V21.3C13.2 21.69 12.89 22 12.5 22C12.11 22 11.8 21.69 11.8 21.3V19.17C10.71 19.07 9.68001 18.75 8.76001 18.24L9.79001 17.21C10.61 17.59 11.53 17.81 12.5 17.81C16.04 17.81 18.92 14.93 18.92 11.4V9.81C18.92 9.43 19.23 9.12 19.62 9.12C20 9.12 20.31 9.43 20.31 9.81Z"
            fill={color}
        />
        <path
            d="M16.92 10.08V11.53C16.92 14.11 14.7 16.18 12.06 15.93C11.78 15.9 11.5 15.85 11.24 15.76L16.92 10.08Z"
            fill={color}
        />
        <path
            d="M22.27 2.23C21.97 1.93 21.48 1.93 21.18 2.23L7.73 15.68C6.7 14.55 6.07999 13.05 6.07999 11.4V9.81001C6.07999 9.43001 5.77 9.12 5.38 9.12C5 9.12 4.69 9.43001 4.69 9.81001V11.4C4.69 13.43 5.47 15.28 6.74 16.67L2.72 20.69C2.42 20.99 2.42 21.48 2.72 21.78C2.88 21.92 3.07 22 3.27 22C3.47 22 3.66 21.92 3.81 21.77L22.27 3.31C22.58 3.01 22.58 2.53 22.27 2.23Z"
            fill={color}
        />
    </svg>
{/if}

{#if icon == 'add-to-call'}
    <svg
        on:click
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.5 5V19"
            stroke="#474B50"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.5 12H19.5"
            stroke="#474B50"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
{/if}

{#if icon == 'loundspeaker'}
    <svg
        on:click
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.16663 4.16669L4.99996 7.50002H1.66663V12.5H4.99996L9.16663 15.8334V4.16669Z"
            fill={color}
            stroke={color}
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.8916 4.10834C17.4539 5.67107 18.3315 7.7903 18.3315 10C18.3315 12.2097 17.4539 14.3289 15.8916 15.8917M12.95 7.05C13.7311 7.83137 14.1699 8.89099 14.1699 9.99584C14.1699 11.1007 13.7311 12.1603 12.95 12.9417"
            stroke={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
{/if}

{#if icon == 'call-history'}
    <svg
        on:click
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Group 10820">
            <g id="Vector">
                <path
                    d="M23.8356 7.74434C23.8334 7.67816 23.816 7.55269 23.8031 7.46748C23.5841 5.90563 23.0177 3.73438 21.6365 2.47337C19.3224 0.363329 13.3971 0.408552 11.6359 0.472802C9.87465 0.537603 3.96173 0.925033 1.81033 3.19666C1.45075 3.57444 1.1375 4.04267 0.879944 4.5881C0.285427 5.84718 0.0808204 7.31582 0.0146403 8.31238C0.0146403 8.31238 -0.00245651 8.52416 0.000300993 8.61516C0.00912501 8.84624 0.0962626 9.1093 0.266676 9.41925C0.353813 9.57753 0.475419 9.71457 0.562004 9.80116C0.658517 9.89767 0.855127 10.075 1.08869 10.1817C1.40828 10.3276 1.67438 10.3946 1.90546 10.3874C2.0756 10.3811 5.63167 9.94924 5.65318 9.94538L5.67828 9.94014C5.86937 9.91504 6.04695 9.86706 6.20661 9.7973C6.62493 9.61448 6.96245 9.28633 7.15795 8.87354C7.28204 8.61102 7.3416 8.32259 7.33085 8.04325L7.28259 6.62452C7.2779 6.49133 7.32588 6.30051 7.35787 6.24812C7.39399 6.19545 7.42267 6.16236 7.44197 6.14195L16.3148 5.81684C16.3363 5.81629 16.352 5.82098 16.3622 5.82512C16.3645 5.82968 16.3664 5.83418 16.3682 5.83826C16.3698 5.84205 16.3712 5.84549 16.3727 5.84828C16.3901 5.89929 16.4193 6.08735 16.4276 6.29417L16.4836 7.70628C16.5106 8.45081 17.0215 9.13991 17.7178 9.37954C17.9591 9.46264 18.1889 9.47746 18.3029 9.48481L18.3123 9.48543L18.3722 9.49177C18.4006 9.4937 21.9216 9.65722 22.0661 9.65115C22.4262 9.63791 22.814 9.43772 23.2516 9.03981C23.4948 8.81866 23.7176 8.45908 23.7816 8.18499C23.8221 8.00823 23.84 7.86346 23.8356 7.74434ZM19.0234 13.1263C18.1137 13.1253 17.2215 13.3758 16.4453 13.8503C15.6691 14.3247 15.0392 15.0046 14.6253 15.8147C14.2114 16.6248 14.0295 17.5335 14.0999 18.4405C14.1703 19.3475 14.346 20.4666 15.5613 21.5057H8.23834C9.86096 20.4668 9.90753 18.9662 9.86096 17.8599C9.81439 16.7535 9.39692 15.695 8.67575 14.8548C7.95458 14.0145 6.97166 13.4413 5.88519 13.2275C4.79873 13.0137 3.67191 13.1716 2.68611 13.6759C1.70031 14.1803 0.912873 15.0016 0.450537 16.0078C-0.0117982 17.014 -0.122137 18.1464 0.137279 19.2229C0.396695 20.2994 1.01078 21.2573 1.88068 21.9424C2.75059 22.6276 3.82573 23.0001 4.93304 23H19.0224C19.6742 23.0053 20.3205 22.8816 20.9242 22.6359C21.5278 22.3902 22.0769 22.0274 22.5396 21.5684C23.0024 21.1095 23.3697 20.5634 23.6203 19.9618C23.871 19.3602 24 18.7149 24 18.0632C24 17.4114 23.871 16.7661 23.6203 16.1645C23.3697 15.5629 23.0024 15.0168 22.5396 14.5579C22.0769 14.0989 21.5278 13.7361 20.9242 13.4904C20.3205 13.2447 19.6752 13.121 19.0234 13.1263Z"
                    fill={color}
                />
                <path
                    d="M23.8356 7.74434C23.8334 7.67816 23.816 7.55269 23.8031 7.46748C23.5841 5.90563 23.0177 3.73438 21.6365 2.47337C19.3224 0.363329 13.3971 0.408552 11.6359 0.472802C9.87465 0.537603 3.96173 0.925033 1.81033 3.19666C1.45075 3.57444 1.1375 4.04267 0.879944 4.5881C0.285427 5.84718 0.0808204 7.31582 0.0146403 8.31238C0.0146403 8.31238 -0.00245651 8.52416 0.000300993 8.61516C0.00912501 8.84624 0.0962626 9.1093 0.266676 9.41925C0.353813 9.57753 0.475419 9.71457 0.562004 9.80116C0.658517 9.89767 0.855127 10.075 1.08869 10.1817C1.40828 10.3276 1.67438 10.3946 1.90546 10.3874C2.0756 10.3811 5.63167 9.94924 5.65318 9.94538L5.67828 9.94014C5.86937 9.91504 6.04695 9.86706 6.20661 9.7973C6.62493 9.61448 6.96245 9.28633 7.15795 8.87354C7.28204 8.61102 7.3416 8.32259 7.33085 8.04325L7.28259 6.62452C7.2779 6.49133 7.32588 6.30051 7.35787 6.24812C7.39399 6.19545 7.42267 6.16236 7.44197 6.14195L16.3148 5.81684C16.3363 5.81629 16.352 5.82098 16.3622 5.82512C16.3645 5.82968 16.3664 5.83418 16.3682 5.83826C16.3698 5.84205 16.3712 5.84549 16.3727 5.84828C16.3901 5.89929 16.4193 6.08735 16.4276 6.29417L16.4836 7.70628C16.5106 8.45081 17.0215 9.13991 17.7178 9.37954C17.9591 9.46264 18.1889 9.47746 18.3029 9.48481L18.3123 9.48543L18.3722 9.49177C18.4006 9.4937 21.9216 9.65722 22.0661 9.65115C22.4262 9.63791 22.814 9.43772 23.2516 9.03981C23.4948 8.81866 23.7176 8.45908 23.7816 8.18499C23.8221 8.00823 23.84 7.86346 23.8356 7.74434ZM19.0234 13.1263C18.1137 13.1253 17.2215 13.3758 16.4453 13.8503C15.6691 14.3247 15.0392 15.0046 14.6253 15.8147C14.2114 16.6248 14.0295 17.5335 14.0999 18.4405C14.1703 19.3475 14.346 20.4666 15.5613 21.5057H8.23834C9.86096 20.4668 9.90753 18.9662 9.86096 17.8599C9.81439 16.7535 9.39692 15.695 8.67575 14.8548C7.95458 14.0145 6.97166 13.4413 5.88519 13.2275C4.79873 13.0137 3.67191 13.1716 2.68611 13.6759C1.70031 14.1803 0.912873 15.0016 0.450537 16.0078C-0.0117982 17.014 -0.122137 18.1464 0.137279 19.2229C0.396695 20.2994 1.01078 21.2573 1.88068 21.9424C2.75059 22.6276 3.82573 23.0001 4.93304 23H19.0224C19.6742 23.0053 20.3205 22.8816 20.9242 22.6359C21.5278 22.3902 22.0769 22.0274 22.5396 21.5684C23.0024 21.1095 23.3697 20.5634 23.6203 19.9618C23.871 19.3602 24 18.7149 24 18.0632C24 17.4114 23.871 16.7661 23.6203 16.1645C23.3697 15.5629 23.0024 15.0168 22.5396 14.5579C22.0769 14.0989 21.5278 13.7361 20.9242 13.4904C20.3205 13.2447 19.6752 13.121 19.0234 13.1263Z"
                    stroke={color}
                />
            </g>
        </g>
    </svg>
{/if}

{#if icon == 'contact-list'}
    <svg
        on:click
        width="22"
        height="25"
        viewBox="0 0 22 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Group 10819">
            <path
                id="Ellipse 131"
                d="M17.261 6.71301C17.261 10.1708 14.4579 12.9739 11.0001 12.9739C7.54234 12.9739 4.73926 10.1708 4.73926 6.71301C4.73926 3.25523 7.54234 0.452148 11.0001 0.452148C14.4579 0.452148 17.261 3.25523 17.261 6.71301ZM6.7374 6.71301C6.7374 9.06725 8.64589 10.9757 11.0001 10.9757C13.3544 10.9757 15.2628 9.06725 15.2628 6.71301C15.2628 4.35878 13.3544 2.45029 11.0001 2.45029C8.64589 2.45029 6.7374 4.35878 6.7374 6.71301Z"
                fill={color}
            />
            <path
                id="Subtract"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.56543 19.2347C0.56543 16.9295 2.43415 15.0608 4.73934 15.0608H17.2611C19.5663 15.0608 21.435 16.9295 21.435 19.2347V23.9304C21.435 24.2185 21.2014 24.4521 20.9132 24.4521H19.8696C19.5814 24.4521 19.3478 24.2185 19.3478 23.9304V19.2347C19.3478 18.0821 18.4135 17.1478 17.2609 17.1478H4.73914C3.58654 17.1478 2.65218 18.0821 2.65218 19.2347V23.9304C2.65218 24.2185 2.41859 24.4521 2.13044 24.4521H1.08717C0.79902 24.4521 0.56543 24.2185 0.56543 23.9304V19.2347Z"
                fill={color}
            />
        </g>
    </svg>
{/if}

{#if icon == 'missed-call'}
    <svg
        on:click
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Group 11161">
            <path
                id="Rectangle 1370"
                d="M0.279952 11.1091C0.585946 5.24451 5.24451 0.585946 11.1091 0.279952C14.1236 0.122666 17.3304 0 20 0C22.6696 0 25.8764 0.122666 28.8909 0.279952C34.7555 0.585946 39.4141 5.24451 39.72 11.1091C39.8773 14.1236 40 17.3304 40 20C40 22.6696 39.8773 25.8764 39.72 28.8909C39.4141 34.7555 34.7555 39.4141 28.8909 39.72C25.8764 39.8773 22.6696 40 20 40C17.3304 40 14.1236 39.8773 11.1091 39.72C5.24451 39.4141 0.585946 34.7555 0.279952 28.8909C0.122666 25.8764 0 22.6696 0 20C0 17.3304 0.122666 14.1236 0.279952 11.1091Z"
                fill="#F54336"
            />
            <g id="Phone" clip-path="url(#clip0_1763_5634)">
                <g id="Page-1">
                    <g id="Artboard">
                        <g id="phone-off">
                            <path
                                id="Shape"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M18.6799 21.3101C19.6948 22.3258 20.8418 23.2004 22.0899 23.9101L23.3599 22.6401C23.6318 22.3712 23.9751 22.1859 24.3491 22.1062C24.723 22.0264 25.112 22.0556 25.4699 22.1901C26.3769 22.5291 27.3199 22.7631 28.2799 22.8901C28.7605 22.958 29.1999 23.1984 29.5164 23.5663C29.8329 23.9343 30.0047 24.4048 29.9999 24.8901V27.8901C30.0011 28.1686 29.944 28.4443 29.8324 28.6994C29.7209 28.9546 29.5572 29.1837 29.352 29.372C29.1468 29.5602 28.9045 29.7036 28.6407 29.7928C28.3769 29.882 28.0973 29.9152 27.8199 29.8901C24.7428 29.5557 21.7869 28.5042 19.1899 26.8201C17.9852 26.0552 16.8685 25.1597 15.8599 24.1501M13.1899 20.8101C11.5058 18.2131 10.4543 15.2573 10.1199 12.1801C10.0949 11.9036 10.1278 11.6249 10.2164 11.3617C10.3051 11.0986 10.4475 10.8568 10.6347 10.6517C10.8219 10.4466 11.0497 10.2828 11.3037 10.1706C11.5577 10.0584 11.8323 10.0004 12.1099 10.0001H15.1099C15.5952 9.99532 16.0657 10.1672 16.4337 10.4836C16.8017 10.8001 17.042 11.2395 17.1099 11.7201C17.2369 12.6801 17.4709 13.6231 17.8099 14.5301C17.9445 14.888 17.9736 15.277 17.8938 15.651C17.8141 16.0249 17.6288 16.3682 17.3599 16.6401L16.0899 17.9101"
                                fill="white"
                            />
                            <path
                                id="Shape_2"
                                d="M31 9L9 31"
                                stroke="white"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_1763_5634">
                <rect width="24" height="24" fill="white" transform="translate(8 8)" />
            </clipPath>
        </defs>
    </svg>
{/if}

{#if icon == 'note'}
    <svg
        on:click
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.33317 1.33325H3.99984C3.64622 1.33325 3.30708 1.47373 3.05703 1.72378C2.80698 1.97382 2.6665 2.31296 2.6665 2.66659V13.3333C2.6665 13.6869 2.80698 14.026 3.05703 14.2761C3.30708 14.5261 3.64622 14.6666 3.99984 14.6666H11.9998C12.3535 14.6666 12.6926 14.5261 12.9426 14.2761C13.1927 14.026 13.3332 13.6869 13.3332 13.3333V5.33325L9.33317 1.33325Z"
            stroke="#0E99D2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.3335 1.33325V5.33325H13.3335"
            stroke="#0E99D2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.6668 8.66675H5.3335"
            stroke="#0E99D2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.6668 11.3333H5.3335"
            stroke="#0E99D2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.66683 6H6.00016H5.3335"
            stroke="#0E99D2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
{/if}

{#if icon == 'outgoing-call'}
    <svg
        on:click
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0.279952 11.1091C0.585946 5.24451 5.24451 0.585946 11.1091 0.279952C14.1236 0.122666 17.3304 0 20 0C22.6696 0 25.8764 0.122666 28.8909 0.279952C34.7555 0.585946 39.4141 5.24451 39.72 11.1091C39.8773 14.1236 40 17.3304 40 20C40 22.6696 39.8773 25.8764 39.72 28.8909C39.4141 34.7555 34.7555 39.4141 28.8909 39.72C25.8764 39.8773 22.6696 40 20 40C17.3304 40 14.1236 39.8773 11.1091 39.72C5.24451 39.4141 0.585946 34.7555 0.279952 28.8909C0.122666 25.8764 0 22.6696 0 20C0 17.3304 0.122666 14.1236 0.279952 11.1091Z"
            fill="#009689"
        />
        <path
            d="M30.9567 15.3043V9.04346H24.6958"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M23.6523 16.3478L30.9567 9.04346"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.913 25.6557V28.7861C29.9142 29.0768 29.8546 29.3644 29.7382 29.6307C29.6218 29.897 29.451 30.136 29.2369 30.3324C29.0227 30.5289 28.7699 30.6785 28.4946 30.7716C28.2193 30.8647 27.9276 30.8993 27.6382 30.8731C24.4272 30.5242 21.3429 29.427 18.633 27.6696C16.1118 26.0675 13.9742 23.93 12.3721 21.4088C10.6086 18.6865 9.51114 15.5872 9.16863 12.3618C9.14255 12.0732 9.17684 11.7824 9.26932 11.5078C9.3618 11.2333 9.51044 10.981 9.70577 10.767C9.90111 10.553 10.1389 10.382 10.4039 10.265C10.6689 10.1479 10.9554 10.0873 11.2451 10.087H14.3756C14.882 10.082 15.3729 10.2614 15.7569 10.5916C16.1409 10.9218 16.3917 11.3804 16.4625 11.8818C16.5951 12.8835 16.8392 13.8675 17.193 14.814C17.3334 15.1875 17.3638 15.5934 17.2805 15.9836C17.1973 16.3738 17.004 16.732 16.7234 17.0157L15.3982 18.3409C16.8836 20.9533 19.0467 23.1163 21.6591 24.6018L22.9843 23.2766C23.268 22.996 23.6262 22.8027 24.0164 22.7195C24.4066 22.6362 24.8125 22.6666 25.186 22.807C26.1325 23.1608 27.1165 23.4049 28.1182 23.5375C28.6251 23.609 29.088 23.8643 29.4189 24.2548C29.7498 24.6454 29.9257 25.144 29.913 25.6557Z"
            fill="white"
        />
    </svg>
{/if}

{#if icon == 'incoming-call'}
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0.279952 11.1091C0.585946 5.24451 5.24451 0.585946 11.1091 0.279952C14.1236 0.122666 17.3304 0 20 0C22.6696 0 25.8764 0.122666 28.8909 0.279952C34.7555 0.585946 39.4141 5.24451 39.72 11.1091C39.8773 14.1236 40 17.3304 40 20C40 22.6696 39.8773 25.8764 39.72 28.8909C39.4141 34.7555 34.7555 39.4141 28.8909 39.72C25.8764 39.8773 22.6696 40 20 40C17.3304 40 14.1236 39.8773 11.1091 39.72C5.24451 39.4141 0.585946 34.7555 0.279952 28.8909C0.122666 25.8764 0 22.6696 0 20C0 17.3304 0.122666 14.1236 0.279952 11.1091Z"
            fill="#607D8A"
        />
        <path
            d="M23.6523 10.0869V16.3478H29.9132"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M30.9567 9.04346L23.6523 16.3478"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.913 25.6557V28.7861C29.9142 29.0768 29.8546 29.3644 29.7382 29.6307C29.6218 29.897 29.451 30.136 29.2369 30.3324C29.0227 30.5289 28.7699 30.6785 28.4946 30.7716C28.2193 30.8647 27.9276 30.8993 27.6382 30.8731C24.4272 30.5242 21.3429 29.427 18.633 27.6696C16.1118 26.0675 13.9742 23.93 12.3721 21.4088C10.6086 18.6865 9.51114 15.5872 9.16863 12.3618C9.14255 12.0732 9.17684 11.7824 9.26932 11.5078C9.3618 11.2333 9.51044 10.981 9.70577 10.767C9.90111 10.553 10.1389 10.382 10.4039 10.265C10.6689 10.1479 10.9554 10.0873 11.2451 10.087H14.3756C14.882 10.082 15.3729 10.2614 15.7569 10.5916C16.1409 10.9218 16.3917 11.3804 16.4625 11.8818C16.5951 12.8835 16.8392 13.8675 17.193 14.814C17.3334 15.1875 17.3638 15.5934 17.2805 15.9836C17.1973 16.3738 17.004 16.732 16.7234 17.0157L15.3982 18.3409C16.8836 20.9533 19.0467 23.1163 21.6591 24.6018L22.9843 23.2766C23.268 22.996 23.6262 22.8027 24.0164 22.7195C24.4066 22.6362 24.8125 22.6666 25.186 22.807C26.1325 23.1608 27.1165 23.4049 28.1182 23.5375C28.6251 23.609 29.088 23.8643 29.4189 24.2548C29.7498 24.6454 29.9257 25.144 29.913 25.6557Z"
            fill="white"
        />
    </svg>
{/if}

{#if icon == 'pause-recording'}
    <svg
        on:click
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Pause" clip-path="url(#clip0_1763_5766)">
            <g id="Page-1">
                <g id="Artboard">
                    <g id="pause-circle">
                        <path
                            id="Oval"
                            d="M11.9999 22.909C18.0248 22.909 22.909 18.0248 22.909 11.9999C22.909 5.97499 18.0248 1.09082 11.9999 1.09082C5.97499 1.09082 1.09082 5.97499 1.09082 11.9999C1.09082 18.0248 5.97499 22.909 11.9999 22.909Z"
                            stroke="#F3BF24"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            id="Shape"
                            d="M9.81787 15.2727V8.72729"
                            stroke="#F3BF24"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            id="Shape_2"
                            d="M14.1816 15.2727V8.72729"
                            stroke="#F3BF24"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </g>
                </g>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_1763_5766">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
{/if}

{#if icon == 'play'}
    <svg
        on:click
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Play">
            <g id="Group">
                <path
                    id="Vector"
                    d="M11.9999 22.909C18.0248 22.909 22.909 18.0248 22.909 11.9999C22.909 5.97499 18.0248 1.09082 11.9999 1.09082C5.97499 1.09082 1.09082 5.97499 1.09082 11.9999C1.09082 18.0248 5.97499 22.909 11.9999 22.909Z"
                    fill="#F3BF24"
                />
                <path
                    id="Vector_2"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.81787 9.50475C9.81787 8.70605 10.708 8.22966 11.3726 8.6727L15.1152 11.1678C15.709 11.5636 15.709 12.4361 15.1153 12.8319L11.3726 15.327C10.708 15.7701 9.81787 15.2937 9.81787 14.495V9.50475Z"
                    fill="white"
                />
            </g>
        </g>
    </svg>
{/if}

{#if icon == 'play-circle'}
    <svg
        on:click
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="play-circle">
            <path
                id="Vector"
                d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
                stroke="#0E99D2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                id="Vector_2"
                d="M7.5 6L12 9L7.5 12V6Z"
                fill="#0E99D2"
                stroke="#0E99D2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
    </svg>
{/if}

{#if icon == 'settings'}
    <svg
        on:click
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="settings" clip-path="url(#clip0_1835_2031)">
            <g {transform}>
                <path
                    id="Vector"
                    d="M12 15.4521C13.6569 15.4521 15 14.109 15 12.4521C15 10.7953 13.6569 9.45215 12 9.45215C10.3431 9.45215 9 10.7953 9 12.4521C9 14.109 10.3431 15.4521 12 15.4521Z"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    id="Vector_2"
                    d="M19.4 15.4521C19.2669 15.7538 19.2272 16.0883 19.286 16.4127C19.3448 16.7371 19.4995 17.0365 19.73 17.2721L19.79 17.3321C19.976 17.5179 20.1235 17.7385 20.2241 17.9813C20.3248 18.2241 20.3766 18.4843 20.3766 18.7471C20.3766 19.01 20.3248 19.2702 20.2241 19.513C20.1235 19.7558 19.976 19.9764 19.79 20.1621C19.6043 20.3481 19.3837 20.4956 19.1409 20.5963C18.8981 20.6969 18.6378 20.7487 18.375 20.7487C18.1122 20.7487 17.8519 20.6969 17.6091 20.5963C17.3663 20.4956 17.1457 20.3481 16.96 20.1621L16.9 20.1021C16.6643 19.8716 16.365 19.717 16.0406 19.6581C15.7162 19.5993 15.3816 19.639 15.08 19.7721C14.7842 19.8989 14.532 20.1094 14.3543 20.3777C14.1766 20.646 14.0813 20.9604 14.08 21.2821V21.4521C14.08 21.9826 13.8693 22.4913 13.4942 22.8664C13.1191 23.2414 12.6104 23.4521 12.08 23.4521C11.5496 23.4521 11.0409 23.2414 10.6658 22.8664C10.2907 22.4913 10.08 21.9826 10.08 21.4521V21.3621C10.0723 21.0312 9.96512 20.7101 9.77251 20.4408C9.5799 20.1716 9.31074 19.9664 9 19.8521C8.69838 19.719 8.36381 19.6793 8.03941 19.7381C7.71502 19.797 7.41568 19.9516 7.18 20.1821L7.12 20.2421C6.93425 20.4281 6.71368 20.5756 6.47088 20.6763C6.22808 20.7769 5.96783 20.8287 5.705 20.8287C5.44217 20.8287 5.18192 20.7769 4.93912 20.6763C4.69632 20.5756 4.47575 20.4281 4.29 20.2421C4.10405 20.0564 3.95653 19.8358 3.85588 19.593C3.75523 19.3502 3.70343 19.09 3.70343 18.8271C3.70343 18.5643 3.75523 18.3041 3.85588 18.0613C3.95653 17.8185 4.10405 17.5979 4.29 17.4121L4.35 17.3521C4.58054 17.1165 4.73519 16.8171 4.794 16.4927C4.85282 16.1683 4.81312 15.8338 4.68 15.5321C4.55324 15.2364 4.34276 14.9841 4.07447 14.8065C3.80618 14.6288 3.49179 14.5334 3.17 14.5321H3C2.46957 14.5321 1.96086 14.3214 1.58579 13.9464C1.21071 13.5713 1 13.0626 1 12.5321C1 12.0017 1.21071 11.493 1.58579 11.1179C1.96086 10.7429 2.46957 10.5321 3 10.5321H3.09C3.42099 10.5244 3.742 10.4173 4.0113 10.2247C4.28059 10.0321 4.48572 9.76288 4.6 9.45215C4.73312 9.15053 4.77282 8.81596 4.714 8.49156C4.65519 8.16716 4.50054 7.86783 4.27 7.63215L4.21 7.57215C4.02405 7.3864 3.87653 7.16583 3.77588 6.92303C3.67523 6.68023 3.62343 6.41998 3.62343 6.15715C3.62343 5.89432 3.67523 5.63406 3.77588 5.39127C3.87653 5.14847 4.02405 4.92789 4.21 4.74215C4.39575 4.5562 4.61632 4.40868 4.85912 4.30803C5.10192 4.20738 5.36217 4.15558 5.625 4.15558C5.88783 4.15558 6.14808 4.20738 6.39088 4.30803C6.63368 4.40868 6.85425 4.5562 7.04 4.74215L7.1 4.80215C7.33568 5.03269 7.63502 5.18733 7.95941 5.24615C8.28381 5.30497 8.61838 5.26526 8.92 5.13215H9C9.29577 5.00539 9.54802 4.7949 9.72569 4.52661C9.90337 4.25832 9.99872 3.94394 10 3.62215V3.45215C10 2.92172 10.2107 2.41301 10.5858 2.03793C10.9609 1.66286 11.4696 1.45215 12 1.45215C12.5304 1.45215 13.0391 1.66286 13.4142 2.03793C13.7893 2.41301 14 2.92172 14 3.45215V3.54215C14.0013 3.86393 14.0966 4.17832 14.2743 4.44661C14.452 4.7149 14.7042 4.92539 15 5.05215C15.3016 5.18526 15.6362 5.22497 15.9606 5.16615C16.285 5.10733 16.5843 4.95269 16.82 4.72215L16.88 4.66215C17.0657 4.4762 17.2863 4.32868 17.5291 4.22803C17.7719 4.12738 18.0322 4.07558 18.295 4.07558C18.5578 4.07558 18.8181 4.12738 19.0609 4.22803C19.3037 4.32868 19.5243 4.4762 19.71 4.66215C19.896 4.84789 20.0435 5.06847 20.1441 5.31127C20.2448 5.55406 20.2966 5.81432 20.2966 6.07715C20.2966 6.33998 20.2448 6.60023 20.1441 6.84303C20.0435 7.08583 19.896 7.3064 19.71 7.49215L19.65 7.55215C19.4195 7.78783 19.2648 8.08716 19.206 8.41156C19.1472 8.73595 19.1869 9.07053 19.32 9.37215V9.45215C19.4468 9.74792 19.6572 10.0002 19.9255 10.1778C20.1938 10.3555 20.5082 10.4509 20.83 10.4521H21C21.5304 10.4521 22.0391 10.6629 22.4142 11.0379C22.7893 11.413 23 11.9217 23 12.4521C23 12.9826 22.7893 13.4913 22.4142 13.8664C22.0391 14.2414 21.5304 14.4521 21 14.4521H20.91C20.5882 14.4534 20.2738 14.5488 20.0055 14.7265C19.7372 14.9041 19.5268 15.1564 19.4 15.4521Z"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1835_2031">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.452148)"
                    />
                </clipPath>
            </defs>
        </g>
    </svg>
{/if}

{#if icon == 'slack'}
    <svg
        on:click
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="slack 1">
            <path
                id="Vector"
                d="M14.2874 9.2019C14.1553 8.80881 13.73 8.59776 13.3377 8.72879L8.63722 10.3022C8.24292 10.4352 8.03177 10.8603 8.16386 11.2524L9.686 15.7845C9.8191 16.1806 10.2474 16.3866 10.6357 16.2576C14.7588 14.8102 16.1578 14.7692 15.8096 13.735L14.2874 9.2019ZM10.8709 14.5972L9.82611 11.4875L13.1026 10.3912L14.1473 13.5009L10.8709 14.5972Z"
                fill={color}
            />
            <path
                id="Vector_2"
                d="M20.6232 11.3115L19.051 11.8336L18.0072 8.73287L19.5694 8.21275C22.7578 7.1775 21.2417 2.25733 17.9442 3.33058L16.374 3.85271L15.8236 2.20632C14.7818 -0.975443 9.87517 0.534917 10.93 3.8337L11.4814 5.4841L8.20892 6.57636L7.65851 4.93197C6.62474 1.76021 1.71007 3.25157 2.76586 6.55936L3.31727 8.20775L1.7581 8.72387C-0.904886 9.58808 -0.438537 13.574 2.45362 13.7271C2.96 13.7941 3.3543 13.624 4.95149 13.0849L5.99527 16.1847L4.4321 16.7048C1.72408 17.588 2.30751 21.5959 5.08859 21.703C5.638 21.785 6.09434 21.5839 7.62449 21.0658L8.1799 22.7252C9.27972 25.866 14.1173 24.3656 13.0686 21.0828L12.5171 19.4324L15.7986 18.3352L16.353 19.9956C17.4528 23.1333 22.2914 21.637 21.2417 18.3532L20.6912 16.7038L22.2494 16.1847C25.4198 15.1884 23.9257 10.2342 20.6232 11.3115ZM21.7851 14.7593L19.5034 15.5185C19.1111 15.6485 18.8969 16.0746 19.029 16.4677L19.8136 18.8203C20.2599 20.2176 18.2224 20.7938 17.7721 19.5114L16.9845 17.1499C16.8544 16.7638 16.4391 16.5447 16.0338 16.6758L11.3283 18.2481C10.935 18.3792 10.7238 18.8043 10.8549 19.1974L11.6405 21.5499C12.0878 22.9483 10.0483 23.5234 9.59896 22.2401L8.80937 19.8785C8.67827 19.4834 8.25096 19.2744 7.86066 19.4044C6.38156 19.9025 5.43185 20.2426 5.2287 20.2116C3.96475 20.1596 3.81164 18.4862 4.90045 18.1301L7.18316 17.3709C7.57745 17.2409 7.78961 16.8118 7.65851 16.4197L6.13537 11.8966C6.00428 11.5055 5.58096 11.2965 5.18767 11.4235C3.44436 12.0107 2.73483 12.2587 2.63276 12.2367C2.60674 12.2337 2.57972 12.2307 2.5547 12.2297C1.28775 12.1777 1.13764 10.5023 2.22545 10.1482L4.50215 9.39503C4.89645 9.265 5.11061 8.8389 4.97851 8.44481L4.19192 6.09324C3.74659 4.69991 5.80313 4.09277 6.23345 5.40208L7.02304 7.76364C7.15414 8.15674 7.58546 8.36979 7.97175 8.23776L12.6673 6.67038C13.0615 6.53835 13.2727 6.11325 13.1416 5.72116L12.356 3.36859C11.9117 1.98026 13.9662 1.36412 14.3975 2.67843L15.1871 5.03999C15.3182 5.43209 15.7406 5.64614 16.1358 5.51411L18.4115 4.75693C19.8016 4.30282 20.413 6.36231 19.1001 6.78941L16.8184 7.54859C16.4241 7.67862 16.2119 8.10772 16.343 8.49982L17.8651 13.0229C17.9972 13.414 18.4216 13.628 18.8128 13.495L21.0895 12.7378C22.4816 12.2847 23.095 14.3462 21.7851 14.7593Z"
                fill={color}
            />
        </g>
    </svg>
{/if}

{#if icon == 'close'}
    <svg
        on:click
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="x-circle">
            <path
                id="Vector"
                d="M15.9998 29.3334C23.3636 29.3334 29.3332 23.3639 29.3332 16.0001C29.3332 8.63628 23.3636 2.66675 15.9998 2.66675C8.63604 2.66675 2.6665 8.63628 2.6665 16.0001C2.6665 23.3639 8.63604 29.3334 15.9998 29.3334Z"
                stroke="#EEEEEE"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                id="Vector_2"
                d="M20 12L12 20"
                stroke="#1F222A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                id="Vector_3"
                d="M12 12L20 20"
                stroke="#1F222A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
    </svg>
{/if}

{#if icon == 'logo-brand'}
    <svg
        width="33"
        height="26"
        viewBox="0 0 33 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Group 133">
            <path
                id="Vector 13"
                d="M0.412254 15.6674C0.357365 15.0338 0.165396 13.2963 2.00794 12.8331C3.00546 12.5823 4.27673 12.6447 4.9291 13.5335C5.58148 14.4223 5.87064 15.2932 5.10852 15.9839C4.45497 16.5762 3.68649 17.0277 2.35133 17.1762C1.32904 17.29 0.494233 16.6138 0.412254 15.6674Z"
                fill="#1BDE6C"
            />
            <path
                id="Vector 15"
                d="M28.8047 12.9917C27.403 12.7515 27.7388 10.7107 29.0498 9.74835C29.7608 9.22644 30.0661 9.5864 31.2137 9.29785C32.2112 9.04704 32.7486 10.3157 32.5952 10.8221C32.3867 11.5105 32.4356 12.4074 31.695 12.5769C30.6123 12.8248 30.5569 13.292 28.8047 12.9917Z"
                fill="#FF3E13"
            />
            <path
                id="Vector 16"
                d="M7.24537 21.5061L8.93847 20.1757C14.0332 16.7423 17.3973 14.5141 23.1335 12.8633C26.566 11.8755 25.5799 15.816 24.7966 16.5003C24.0134 17.1847 22.915 17.825 21.7326 18.7057C17.6866 21.7194 15.0471 23.1317 10.3614 25.2145C8.65749 25.9719 7.63989 25.6804 6.67807 25.2048C5.39564 24.5706 5.72158 22.7034 7.24537 21.5061Z"
                fill="#FFC20D"
            />
            <path
                id="Vector 17"
                d="M8.62135 9.12227L10.3145 7.79194C15.4092 4.35856 18.7733 2.13032 24.5095 0.479514C27.942 -0.508321 26.9559 3.4322 26.1726 4.11654C25.3894 4.80088 24.291 5.4412 23.1086 6.32186C19.0625 9.33561 16.423 10.7479 11.7374 12.8307C10.0335 13.5881 9.01587 13.2966 8.05405 12.821C6.77162 12.1869 7.09755 10.3196 8.62135 9.12227Z"
                fill="#2D71F3"
            />
        </g>
    </svg>
{/if}

{#if icon == 'keyboard-arrow-up'}
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="keyboard-arrow-up">
            <path
                id="Vector"
                d="M15.88 9.29006L12 13.1701L8.11998 9.29006C7.72998 8.90006 7.09998 8.90006 6.70998 9.29006C6.31998 9.68006 6.31998 10.3101 6.70998 10.7001L11.3 15.2901C11.69 15.6801 12.32 15.6801 12.71 15.2901L17.3 10.7001C17.69 10.3101 17.69 9.68006 17.3 9.29006C16.91 8.91006 16.27 8.90006 15.88 9.29006Z"
                fill="#444444"
            />
            <path
                id="Vector_2"
                d="M15.88 9.28957L12 13.1696L8.11998 9.28957C7.72998 8.89957 7.09998 8.89957 6.70998 9.28957C6.31998 9.67957 6.31998 10.3096 6.70998 10.6996L11.3 15.2896C11.69 15.6796 12.32 15.6796 12.71 15.2896L17.3 10.6996C17.69 10.3096 17.69 9.67957 17.3 9.28957C16.91 8.90957 16.27 8.89957 15.88 9.28957Z"
                fill="#474B50"
            />
        </g>
    </svg>
{/if}

{#if icon == 'keyboard-arrow-down'}
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="keyboard-arrow-down">
            <path
                id="Vector"
                d="M15.88 14.7099L12 10.8299L8.11998 14.7099C7.72998 15.0999 7.09998 15.0999 6.70998 14.7099C6.31998 14.3199 6.31998 13.6899 6.70998 13.2999L11.3 8.70994C11.69 8.31994 12.32 8.31994 12.71 8.70994L17.3 13.2999C17.69 13.6899 17.69 14.3199 17.3 14.7099C16.91 15.0899 16.27 15.0999 15.88 14.7099Z"
                fill="#444444"
            />
            <path
                id="Vector_2"
                d="M15.88 14.7104L12 10.8304L8.11998 14.7104C7.72998 15.1004 7.09998 15.1004 6.70998 14.7104C6.31998 14.3204 6.31998 13.6904 6.70998 13.3004L11.3 8.71043C11.69 8.32043 12.32 8.32043 12.71 8.71043L17.3 13.3004C17.69 13.6904 17.69 14.3204 17.3 14.7104C16.91 15.0904 16.27 15.1004 15.88 14.7104Z"
                fill="#474B50"
            />
        </g>
    </svg>
{/if}

{#if icon == 'logout'}
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="power">
            <path
                id="Vector"
                d="M15.3 5.53333C16.3487 6.58232 17.0627 7.91869 17.3519 9.37348C17.6411 10.8283 17.4924 12.3361 16.9247 13.7065C16.357 15.0768 15.3957 16.248 14.1624 17.072C12.9291 17.896 11.4791 18.3358 9.99585 18.3358C8.5126 18.3358 7.06265 17.896 5.82933 17.072C4.59602 16.248 3.63472 15.0768 3.06699 13.7065C2.49926 12.3361 2.35059 10.8283 2.63978 9.37348C2.92897 7.91869 3.64304 6.58232 4.69169 5.53333"
                stroke="#EF3333"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                id="Vector_2"
                d="M10 1.66663V9.99996"
                stroke="#EF3333"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
    </svg>
{/if}

{#if icon == 'search'}
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="search">
            <path
                id="Vector"
                d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                stroke="#474B50"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                id="Vector_2"
                d="M20.9999 20.9999L16.6499 16.6499"
                stroke="#474B50"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
    </svg>
{/if}

{#if icon === 'attachment'}
    <svg 
        baseProfile="tiny" 
        height="24px" 
        version="1.2" 
        viewBox="0 0 24 24" 
        width="24px" 
        xml:space="preserve" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <g>
            <path stroke={color} d="M18.364,6.635c-1.561-1.559-4.1-1.559-5.658,0L8.172,11.17c-0.473,0.473-0.733,1.1-0.733,1.77   c0,0.668,0.261,1.295,0.732,1.768c0.487,0.486,1.128,0.73,1.769,0.73c0.64,0,1.279-0.242,1.767-0.73l2.122-2.121   c0.391-0.395,0.586-0.904,0.586-1.414c0-0.512-0.195-1.023-0.586-1.414l-3.536,3.535c-0.193,0.195-0.511,0.195-0.708-0.002   c-0.127-0.127-0.146-0.275-0.146-0.352c0-0.078,0.019-0.227,0.146-0.354l4.535-4.537c0.778-0.779,2.048-0.779,2.83,0   c0.779,0.779,0.779,2.049,0,2.828l-4.537,4.537l-2.535,2.535c-0.779,0.779-2.049,0.779-2.828,0c-0.78-0.779-0.78-2.049,0-2.828   l0.095-0.096c-0.451-0.6-0.702-1.359-0.702-2.125l-0.807,0.807c-1.56,1.559-1.56,4.098,0,5.656c0.779,0.779,1.804,1.17,2.828,1.17   s2.049-0.391,2.828-1.17l7.072-7.072C19.924,10.732,19.924,8.195,18.364,6.635z"/>
        </g>
    </svg>
{/if}